<template>
  <div class="background">
    <video
      ref="video"
      id="fullscreenVideo"
      style="width: 100%"
      autoplay
      controls
    >
      <source :src="videoPath" type="video/mp4" />
    </video>
    <div id="videoBackOverlayBottomRight" style="z-index: 100">
      <img
        src="@/assets/ZURUECK.png"
        style="width: 7%"
        alt="Back Button"
        @click="backClicked()"
      />
    </div>
  </div>
</template>

<script>
import { videoSettings } from "../VideoSettings";

export default {
  name: "Video",
  data() {
    return {
      videoPath: videoSettings[this.$route.params.page].videoPath,
      backDestinationName:
        videoSettings[this.$route.params.page].backDestinationName,
      backDestinationParam:
        videoSettings[this.$route.params.page].backDestinationParam,
    };
  },
  methods: {
    backClicked() {
      this.$router.push({
        name: this.backDestinationName,
        params: { page: this.backDestinationParam },
      });
    },
  },
  created() {
    if (
      !this.videoPath.startsWith("https://") &&
      !this.videoPath.startsWith("http://")
    ) {
      this.videoPath = "https://my.lrinfomanager.com/" + this.videoPath;
    }
  },
  mounted() {
    this.$refs.video.volume = 0.5;
  },
};
</script>

<style scoped>
.background {
  width: 100%;
  height: 100%;
  background-size: contain;
}

#overlayBottomRight {
  position: absolute;
  bottom: 2%;
  /* background: rgba(0, 0, 0, 0.5); */
  width: 100%;
  right: 2%;
  text-align: right;
  z-index: 1000;
}

#videoBackOverlayBottomRight {
  position: absolute;
  bottom: 10%;
  /* background: rgba(0, 0, 0, 0.5); */
  width: 100%;
  right: 2%;
  text-align: right;
  z-index: 1000;
}

@media (max-height: 500px) {
  #videoBackOverlayBottomRight {
    bottom: 20%;
  }
}

@media (max-width: 800px) {
  #videoBackOverlayBottomRight {
    bottom: 20%;
  }
}

#overlayBottomRightInfo {
  position: absolute;
  bottom: 2%;
  /* background: rgba(0, 0, 0, 0.5); */
  width: 90%;
  /* padding: 30px; */
  text-align: right;
}
</style>